(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rp-ups-account"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rp-ups-account')) {
    customElements.define('rp-ups-account', class extends HTMLElement {
      connectedCallback() {
        this.on = this.querySelector('[data-rp-ups-on]');
        this.confirmBox = this.querySelector('[data-rp-ups-confirm]');
        this.fields = this.querySelector('[data-rp-ups-fields]');
        this.acct = this.querySelector('[data-rp-ups-acct]');
        this.zip = this.querySelector('[data-rp-ups-zip]');
        this.svc = this.querySelector('[data-rp-ups-svc]');
        this.msg = this.querySelector('[data-rp-ups-msg]');
        this.acctErr = this.querySelector('[data-rp-ups-acct-err]');
        this.zipErr = this.querySelector('[data-rp-ups-zip-err]');
        this.vbtn = this.querySelector('[data-rp-ups-verify]');
        this.vstatus = this.querySelector('[data-rp-ups-vstatus]');
        this.verified = this.dataset.verified === 'Yes' ? this.key() : '';
        this.bypass = '';
        var self = this, t = null;
        this.vbtn.addEventListener('click', function () { if (self.check()) self.verify(); });
        var save = function () { clearTimeout(t); self.pending = true; t = setTimeout(function () { self.save(); }, 450); };
        this.flush = function () { clearTimeout(t); return self.save(); };
        this.on.addEventListener('change', function () {
          self.fields.hidden = !self.on.checked;
          self.toggleAttribute('data-on', self.on.checked);
          if (!self.on.checked) { self.mark(true); if (self.confirmBox) self.confirmBox.checked = false; }
          self.save();
        });
        [this.acct, this.zip].forEach(function (el) {
          el.addEventListener('input', function () {
            if (el === self.acct) {
              var c = self.clean(el.value);
              if (c !== el.value) el.value = c;
            }
            if (el.getAttribute('aria-invalid') === 'true') self.check();
            if (self.verified && self.verified !== self.key()) { self.verified = ''; self.vstate('', ''); }
            save();
          });
          el.addEventListener('blur', function () {
            if (self.on.checked && el.value.trim() !== '' && self.check() && self.verified !== self.key()) self.verify();
          });
        });
        this.svc.addEventListener('change', function () { self.save(); });
        if (this.confirmBox) this.confirmBox.addEventListener('change', function () { if (self.confirmBox.checked) self.show('', false); self.save(); });
        var info = this.querySelector('[data-rp-ups-info]'), help = this.querySelector('[data-rp-ups-help]');
        info.addEventListener('click', function () {
          help.hidden = !help.hidden;
          info.setAttribute('aria-expanded', String(!help.hidden));
        });
        // Block checkout while the box is ticked but a field is blank or the wrong format. Covers the click
        // and the Enter-key form submit (the checkout button is the cart form's default submitter).
        this.block = function (e) {
          if (!self.isConnected || !self.on.checked) return false;
          // Second, deliberate confirmation: own-account shipping is not standard shipping.
          if (self.confirmBox && !self.confirmBox.checked) {
            e.preventDefault(); e.stopImmediatePropagation();
            self.show('Check the box to confirm you have a UPS account, or uncheck "Ship on my own UPS account" to ship another way.', true);
            self.confirmBox.focus();
            return true;
          }
          if (self.check()) {
            var btn = e.submitter || e.target.closest('#checkout, [name="checkout"]');
            // Not yet accepted by UPS for these values: check with UPS first, then continue only if UPS accepts it
            // (or if UPS cannot be reached; the order is re-checked and held after checkout in that case).
            // UPS could not be reached for these exact values: let checkout through (the order check runs after).
            if (self.verified !== self.key() && self.bypass !== self.key()) {
              e.preventDefault(); e.stopImmediatePropagation();
              self.verify().then(function (res) {
                if (res !== false) return self.flush().then(function () { btn.click(); });
                // Say it next to the checkout button too; the verify status line can be scrolled out of view.
                self.show('UPS did not accept that account number and ZIP. Check both, or uncheck the box to ship another way.', true);
                self.acct.focus();
              });
              return true;
            }
            // Valid, but the last keystroke may not be saved yet: save first, then continue to checkout.
            if (!self.pending) return false;
            e.preventDefault(); e.stopImmediatePropagation();
            self.flush().then(function () { btn.click(); });
            return true;
          }
          e.preventDefault(); e.stopImmediatePropagation();
          self.show('Fill in your UPS account number and its ZIP code, or uncheck the box.', true);
          (self.acct.getAttribute('aria-invalid') === 'true' ? self.acct : self.zip).focus();
          return true;
        };
        this.guard = function (e) {
          if (e.target.closest && e.target.closest('#checkout, [name="checkout"]')) self.block(e);
        };
        this.guardSubmit = function (e) {
          if (e.submitter && e.submitter.matches('#checkout, [name="checkout"]')) self.block(e);
        };
        document.addEventListener('click', this.guard, true);
        document.addEventListener('submit', this.guardSubmit, true);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.guard, true);
        document.removeEventListener('submit', this.guardSubmit, true);
      }
      // Marks each field and returns true when both are valid.
      check() {
        var a = this.clean(this.acct.value), z = this.zip.value.trim();
        var aMsg = '';
        if (a === '') aMsg = 'Enter your UPS account number.';
        else if (/^\d{9}$/.test(a)) aMsg = 'That looks like a FedEx account number (9 digits). We can only bill UPS accounts.';
        else if (a.length !== 6) aMsg = 'UPS account numbers are exactly 6 letters and numbers. We can only bill UPS accounts.';
        var zMsg = z === '' ? 'Enter the ZIP or postal code on that UPS account.' : (z.length >= 3 ? '' : 'That ZIP or postal code looks too short.');
        this.field(this.acct, this.acctErr, aMsg);
        this.field(this.zip, this.zipErr, zMsg);
        if (!aMsg && !zMsg) this.show('', false);
        return !aMsg && !zMsg;
      }
      key() { return this.clean(this.acct && this.acct.value) + '|' + (this.zip ? this.zip.value.trim().toUpperCase() : ''); }
      // Asks UPS (through the RestoPower label service) whether the account number + ZIP is a real UPS account.
      // Resolves true (accepted), false (rejected) or null (UPS could not be reached).
      verify() {
        var self = this, k = this.key();
        if (this.verifying) return this.verifying;
        this.vbtn.disabled = true; this.vstate('Checking with UPS...', '');
        this.verifying = fetch('https://rp-ups-labels.ups-labels.workers.dev/public/verify', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ account: this.clean(this.acct.value), zip: this.zip.value.trim() })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.ok) { self.verified = k; self.vstate('UPS accepted this account.', 'ok'); return self.flush().then(function () { return true; }); }
          self.verified = '';
          if (!d.unreachable && !/reach UPS/i.test(d.reason || '')) self.rejected = k;
          if (d.unreachable || /reach UPS/i.test(d.reason || '')) { self.bypass = k; self.vstate(d.reason, ''); return null; }
          self.vstate(d.reason || 'UPS did not accept that account number and ZIP.', 'bad');
          return false;
        }).catch(function () {
          self.bypass = k;
          self.vstate('We could not reach UPS just now. You can still check out; we will confirm the account by email.', ''); return null;
        }).finally(function () { self.vbtn.disabled = false; self.verifying = null; });
        return this.verifying;
      }
      vstate(text, kind) { this.vstatus.textContent = text; this.vstatus.className = 'rp-ups__vstatus' + (kind ? ' rp-ups__vstatus--' + kind : ''); }
      field(input, err, text) { input.setAttribute('aria-invalid', text ? 'true' : 'false'); err.textContent = text; }
      mark(clear) { if (clear) { this.field(this.acct, this.acctErr, ''); this.field(this.zip, this.zipErr, ''); this.show('', false); } }
      clean(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
      valid() { return /^[A-Z0-9]{6}$/.test(this.clean(this.acct.value)) && this.zip.value.trim().length >= 3; }
      show(text, bad) { this.msg.textContent = text; this.msg.classList.toggle('rp-ups__msg--bad', !!bad); }
      save() {
        this.pending = false;
        var on = this.on.checked, ok = this.valid();
        var attrs = on && ok ? {
          'Ship on customer UPS account': 'Yes',
          'Customer UPS account #': this.clean(this.acct.value),
          'UPS account ZIP': this.zip.value.trim(),
          'UPS service requested': this.svc.value,
          'UPS account verified': this.verified === this.key() ? 'Yes' : '',
          'UPS account confirmed': this.confirmBox && this.confirmBox.checked ? 'Yes' : ''
        } : { 'Ship on customer UPS account': '', 'Customer UPS account #': '', 'UPS account ZIP': '', 'UPS service requested': '', 'UPS account verified': '', 'UPS account confirmed': '' };
        var self = this;
        return fetch(this.dataset.cartUpdateUrl || '/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(function (r) {
          // A save that lands after UPS rejected these same values must not replace the rejection with "Saved".
          if (on && ok && self.rejected === self.key()) return self.show('UPS did not accept that account number and ZIP. Check both, or uncheck the box to ship another way.', true);
          if (on && ok) self.show(r.ok ? (self.verified === self.key() ? 'Saved. At checkout, choose "Bill my own UPS account" ($7.00 handling fee).' : 'Saved. Click "Verify with UPS" before checkout.') : 'Could not save, please try again.', !r.ok);
          if (!on) self.show('', false);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
